export const ECHO_QUEUE_ID_PREFIX = 'assistant.echo';

export function createEchoQueueGroupId(sessionToken: string): string {
  return `${ECHO_QUEUE_ID_PREFIX}.${sessionToken}`;
}

export function isEchoQueueGroupId(
  groupId: string | number | undefined,
): groupId is string {
  return (
    typeof groupId === 'string' && groupId.startsWith(ECHO_QUEUE_ID_PREFIX)
  );
}

export function getEchoSessionTokenFromQueueGroupId(
  groupId: string | number | undefined,
): string | null {
  if (!isEchoQueueGroupId(groupId)) {
    return null;
  }

  const sessionToken = groupId.slice(`${ECHO_QUEUE_ID_PREFIX}.`.length).trim();
  return sessionToken ? sessionToken : null;
}
